import Vue from "vue";
import Vuex from 'vuex';

Vue.use(Vuex);


export default new Vuex.Store({
  state: {
    detailData: JSON.parse(localStorage.getItem('scoredetail')) || null,
    infoDetailData: JSON.parse(localStorage.getItem('infodetail')) || null,
    scoreDetailData:JSON.parse(localStorage.getItem('sfsscoredetail'))||null,
    dingInfoDetailData:JSON.parse(localStorage.getItem('dingInfoDetail'))||null
  },
  mutations: {
    setScoreDetail(state, payload) {
      state.detailData = payload
      localStorage.setItem('scoredetail', JSON.stringify(payload))
    },
    clearScoreDetail(state) {
      state.detailData = null
      localStorage.removeItem('scoredetail')
    },

    setInfoDetail(state, payload) {
      state.infoDetailData = payload
      localStorage.setItem('infodetail', JSON.stringify(payload))
    },
    clearInfoDetail(state) {
      state.infoDetailData = null,
        localStorage.removeItem('infodetail')
    },

    setSfsScoreDetail(state, payload) {
      state.scoreDetailData = payload
      localStorage.setItem('sfsscoredetail', JSON.stringify(payload))
    },
    clearSfsScoreDetail(state) {
      state.scoreDetailData = null
      localStorage.removeItem('sfsscoredetail')
    },

    setDingInfoDetail(state, payload) {
      state.dingInfoDetailData = payload
      localStorage.setItem('dingInfoDetail', JSON.stringify(payload))
    },
    clearDingInfoDetail(state) {
      state.dingInfoDetailData = null
      localStorage.removeItem('dingInfoDetail')
    },
  },
  getters: {
    getScoreDetail(state) {
      return state.detailData
    },

    getInfoDetail(state) {
      return state.infoDetailData
    },

    getSfsScoreDetail(state){
      return state.scoreDetailData
    },

    getDingInfoDetail(state){
      return state.dingInfoDetailData
    }
  }
})